import React from 'react';
import Skeleton from 'react-loading-skeleton';

import tailwindConfig from '../../../utils/tailwindColors';

export type TopStatsData = {
  totalCopros: number;
  coprosWithMoreThan3Sales24m: number;
  agThisQuarter: number;
};

interface TopStatsProps {
  stats: TopStatsData | null;
  loading: boolean;
  years?: number[];
}

const StatsSkeletonCard: React.FC = () => (
  <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
    <Skeleton
      width={60}
      height={32}
      baseColor="#f1f5f9"
      highlightColor={`${tailwindConfig.theme.extend.colors['rgpd-blue']}45`}
      className="mb-2"
    />
    <Skeleton
      width={120}
      height={16}
      baseColor="#f1f5f9"
      highlightColor={`${tailwindConfig.theme.extend.colors['rgpd-blue']}45`}
    />
  </div>
);

const TopStats: React.FC<TopStatsProps> = ({ stats, loading, years = [] }) => {
  return (
    <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
      {loading && (
        <>
          <StatsSkeletonCard />
          <StatsSkeletonCard />
          <StatsSkeletonCard />
        </>
      )}
      {!loading && (
        <>
          <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
            <div className="text-2xl font-bold text-slate-900">{stats?.totalCopros ?? 0}</div>
            <div className="text-xs tracking-wide text-slate-500 uppercase">Total Copropriétés</div>
          </div>
          <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
            <div className="text-2xl font-bold text-slate-900">{stats?.coprosWithMoreThan3Sales24m ?? 0}</div>
            <div className="text-xs tracking-wide text-slate-500 uppercase">
              {years.length > 0
                ? `Copropriétés avec ventes > 3 (années sélectionnées: ${[...years].sort((a, b) => b - a).join(', ')})`
                : 'Copropriétés avec ventes > 3 (24 derniers mois)'}
            </div>
          </div>
          <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
            <div className="text-2xl font-bold text-slate-900">{stats?.agThisQuarter ?? 0}</div>
            <div className="text-xs tracking-wide text-slate-500 uppercase">
              {(() => {
                const now = new Date();
                const quarter = Math.floor(now.getMonth() / 3) + 1; // 1..4
                return `AG ce trimestre (T${quarter})`;
              })()}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default TopStats;


